var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M17 1L1 17M17 17L1 1","stroke-linecap":"round","stroke-linejoin":"round"}})}
var staticRenderFns = []

export { render, staticRenderFns }